module.exports = __webpack_public_path__ + "img/sybgt.3244660d.jpg";